import React from 'react';
import Raft from '../Raft/Raft';
import panelStyles from '../ArtifactPanel/ArtifactPanel.module.css';
import MessageContent from '../ConversationPanel/MessageContent';
import classnames from 'classnames';
import { AssistantArtifact } from 'components/framework/models';
import viewStyles from '../AssistantView/AssistantView.module.css';
import headerStyles from '../HeaderPanel/HeaderPanel.module.css';
import styles from './ArtifactViewer.module.css';

// Content types without padding.
const NON_CENTERED_CONTENT_TYPES = [
  'text/html',
  'application/vnd.aha.bookmark',
  'application/vnd.aha.react',
];

const ArtifactViewer = ({ artifactData, domain }) => {
  const artifact = new AssistantArtifact(artifactData);

  return (
    <Raft size={'full-screen'}>
      <div className={viewStyles.container}>
        <div
          className={classnames(
            headerStyles.header,
            headerStyles.fullScreen,
            styles.artifactViewerHeader
          )}
        >
          <span className={headerStyles.headerTitle}>
            <aha-ai-icon />
            AI assistant
          </span>
          <div className={styles.artifactViewerWarning}>
            This artifact is AI-generated for {domain}.aha.io and might contain
            unsafe content.
          </div>
          <span className='tw-font-medium'>
            {artifact.fileName || 'Artifact Viewer'}
          </span>
        </div>
        <React.Fragment key={artifact.uniqueId}>
          <div
            className={classnames(panelStyles.artifactBody, {
              [styles.artifactBodyCentered]:
                !NON_CENTERED_CONTENT_TYPES.includes(
                  artifact.contentType || 'text/plain'
                ),
            })}
          >
            <MessageContent
              body={artifact.content || ''}
              contentType={artifact.contentType || 'text/plain'}
            />
          </div>
        </React.Fragment>
      </div>
    </Raft>
  );
};

export default ArtifactViewer;
